import React, { useEffect } from "react";

const ConnectPaypalIdentity = () => {
  useEffect(() => {
    window.paypal.use(["login"], function (login) {
      login.render({
        appid:
          "AbY9ftMWZPSdO79PNQ5kYk34_L6HBIxhW1BnKtXSqHX_wdIOn33Ls2AnVoD7eKd-RuNlc-i0ksSfw0Hm",
        scopes:
          "profile email https://uri.paypal.com/services/paypalattributes",
        containerid: "paypal-login",
        responseType: "code",
        locale: "en-us",
        buttonType: "CWP",
        buttonShape: "pill",
        buttonSize: "sm",
        fullPage: "true",
        returnurl: "https://partner.shipday.com/partner-portal/paypal",
      });
    });
  }, []);

  return (
    <div className="py-4">
      <div className="bankInfoSub w-100 pb-3">
        You will be redirect to paypal to login and allow Shipday to send you
        your affiliate commissions directly to your paypal account on a monthly
        basis.
      </div>
      <div id="paypal-login"></div>
    </div>
  );
};

export default ConnectPaypalIdentity;
